import React from 'react';
import { Loader2, Save, X, Info } from 'lucide-react';
import { PuntoInput } from './PuntoInput';
import { VisitasOrderList } from './VisitasOrderList';

// Problemas que impiden guardar (se explican al usuario antes de enviar).
export const validarRecorrido = (draft, selection) => {
  const p = [];
  if (!draft.nombre?.trim()) p.push('Indica un nombre para el recorrido.');
  if (!draft.fecha_prevista) p.push('Indica la fecha prevista de las visitas.');
  if (!draft.mediador_id) p.push('Selecciona el mediador responsable.');
  const okPunto = (x) => x && ((x.tipo === 'texto' && x.texto?.trim()) || (x.tipo === 'punto' && x.lat != null));
  if (!okPunto(draft.salida)) p.push('Indica el punto de salida (dirección, punto del mapa o ubicación actual).');
  if (!draft.regresar_a_salida && !okPunto(draft.regreso)) p.push('Indica el punto de regreso o marca «Regresar al punto de salida».');
  if (!selection.length) p.push('Selecciona al menos un inmueble en el mapa o en la lista.');
  const sin = selection.filter(a => a.lat == null || a.lng == null);
  if (sin.length) p.push(`${sin.length} inmueble(s) sin coordenadas válidas: quítalos o localízalos (SOLICITAR DATOS A CATASTRO o punto de acceso).`);
  return p;
};

export const RecorridoEditor = ({ draft, setDraft, selection, setSelection, mediadores, isMediador, pick, setPick, onSave, saving, onCancel, editingId, serverProblems }) => {
  const set = (k, v) => setDraft(prev => ({ ...prev, [k]: v }));
  const problemas = validarRecorrido(draft, selection);
  return (
    <div className="flex flex-col gap-3" data-testid="recorrido-editor">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-slate-900">{editingId ? 'Editar recorrido' : 'Crear recorrido'}</h3>
        <button onClick={onCancel} className="text-slate-400 hover:text-slate-700" data-testid="recorrido-editor-close"><X className="w-5 h-5" /></button>
      </div>
      <label className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-600">Nombre del recorrido</span>
        <input value={draft.nombre} onChange={e => set('nombre', e.target.value)} className="input-base text-sm py-1.5" placeholder="Ej.: Visitas Valencia sur" data-testid="recorrido-nombre" />
      </label>
      <div className="grid grid-cols-2 gap-2">
        <label className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-600">Fecha prevista</span>
          <input type="date" value={draft.fecha_prevista} onChange={e => set('fecha_prevista', e.target.value)} className="input-base text-sm py-1.5" data-testid="recorrido-fecha" />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-600">Mediador responsable</span>
          <select value={draft.mediador_id} onChange={e => set('mediador_id', e.target.value)} disabled={isMediador} className="input-base text-sm py-1.5" data-testid="recorrido-mediador">
            <option value="">Selecciona…</option>
            {mediadores.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        </label>
      </div>
      <PuntoInput label="Punto de salida" value={draft.salida} onChange={v => set('salida', v)} onPickOnMap={() => setPick(pick === 'salida' ? null : 'salida')} picking={pick === 'salida'} allowCurrent tid="recorrido-salida" />
      <label className="flex items-center gap-2 text-sm text-slate-700">
        <input type="checkbox" checked={draft.regresar_a_salida} onChange={e => set('regresar_a_salida', e.target.checked)} data-testid="recorrido-regresar-salida" />
        Regresar al punto de salida
      </label>
      {!draft.regresar_a_salida && (
        <PuntoInput label="Punto de regreso" value={draft.regreso} onChange={v => set('regreso', v)} onPickOnMap={() => setPick(pick === 'regreso' ? null : 'regreso')} picking={pick === 'regreso'} allowCurrent tid="recorrido-regreso" />
      )}
      <div>
        <p className="text-xs font-medium text-slate-600 mb-1">Visitas en el orden en que se realizarán ({selection.length})</p>
        <VisitasOrderList items={selection} onChange={setSelection} />
      </div>
      <p className="text-[11px] text-slate-500 flex gap-1.5"><Info className="w-3.5 h-3.5 shrink-0 mt-px" />XÉNICOS guarda el orden que elijas; no se optimiza. Google Maps calculará la conducción entre paradas al abrir el enlace.</p>
      {(problemas.length > 0 || serverProblems?.length > 0) && (
        <ul className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2.5 space-y-1 list-disc pl-6" data-testid="recorrido-problemas">
          {problemas.map(p => <li key={p}>{p}</li>)}
          {(serverProblems || []).map(p => <li key={p}>{p}</li>)}
        </ul>
      )}
      <button onClick={onSave} disabled={saving || problemas.length > 0} className="btn-primary text-sm flex items-center justify-center gap-2 py-2" data-testid="recorrido-guardar">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
        {editingId ? 'Guardar cambios' : 'Guardar recorrido'}
      </button>
    </div>
  );
};

export default RecorridoEditor;
